"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Composer = _interopRequireDefault(require("./Composer"));

var SayButton =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(SayButton, _React$Component);

  function SayButton(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, SayButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SayButton).call(this, props));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      busy: false,
      id: Date.now() + Math.random()
    };
    return _this;
  }

  (0, _createClass2["default"])(SayButton, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.context.cancel(this.state.id);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this2 = this;

      var props = this.props,
          state = this.state;
      props.onClick && props.onClick(event);
      this.setState(function () {
        return {
          busy: true
        };
      },
      /*#__PURE__*/
      (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return props.context.speak({
                  id: state.id,
                  lang: props.lang,
                  onBoundary: props.onBoundary,
                  onEnd: props.onEnd,
                  onError: props.onError,
                  onStart: props.onStart,
                  pitch: props.pitch,
                  rate: props.rate,
                  text: props.speak,
                  voice: props.voice,
                  volume: props.volume
                });

              case 2:
                _this2.setState(function () {
                  return {
                    busy: false
                  };
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          disabled = _this$props.disabled,
          busy = this.state.busy;
      return _react["default"].createElement("button", {
        disabled: typeof disabled === 'boolean' ? disabled : busy,
        onClick: this.handleClick
      }, children);
    }
  }]);
  return SayButton;
}(_react["default"].Component);

var SayButtonWithContext = function SayButtonWithContext(props) {
  return _react["default"].createElement(_Composer["default"], {
    speechSynthesis: props.speechSynthesis,
    speechSynthesisUtterance: props.speechSynthesisUtterance
  }, function (context) {
    return _react["default"].createElement(SayButton, (0, _extends2["default"])({
      context: context
    }, props));
  });
};

SayButtonWithContext.propTypes = {
  lang: _propTypes["default"].string,
  onBoundary: _propTypes["default"].func,
  onEnd: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onStart: _propTypes["default"].func,
  pitch: _propTypes["default"].number,
  rate: _propTypes["default"].number,
  speak: _propTypes["default"].string,
  voice: _propTypes["default"].oneOfType([_propTypes["default"].any, _propTypes["default"].func]),
  volume: _propTypes["default"].number
};
var _default = SayButtonWithContext;
exports["default"] = _default;